import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Earliest tracked match for a club in a league on/after a date.
 * Used to explain tenures whose counted matches begin later than the
 * appointment (e.g. the club was outside our tracked competitions).
 */
export const useFirstTrackedMatch = (
  clubId?: string | null,
  league?: string | null,
  startDate?: string | null,
) => {
  return useQuery({
    queryKey: ["first-tracked-match", clubId, league, startDate],
    enabled: !!clubId && !!league && !!startDate,
    staleTime: 24 * 60 * 60 * 1000,
    queryFn: async (): Promise<string | null> => {
      const { data, error } = await supabase
        .from("matches")
        .select("match_date")
        .eq("league", league!)
        .or(`home_club_id.eq.${clubId},away_club_id.eq.${clubId}`)
        .gte("match_date", startDate!)
        .order("match_date", { ascending: true })
        .limit(1);
      if (error) throw error;
      return data?.[0]?.match_date ?? null;
    },
  });
};
